
import download from 'downloadjs';
import loadingProgress from '@/classes/LoadingProgress';

const DISPO_REGEX = /filename="(.*)"/;

function getFilename(xhr: XMLHttpRequest): string  {

    const disposition = xhr.getResponseHeader('Content-Disposition') || '';
    const matches = disposition.match(DISPO_REGEX);

    return null == matches ? 'unknown' : matches[1];
}

function getMimeType(xhr: XMLHttpRequest): string | undefined {
    return xhr.getResponseHeader('Content-Type') || undefined;
}

export default function binaryDownload(method: string, url: string, body?: string) {

    loadingProgress.start();

    return new Promise((resolve, reject) => {

        const xhr = new XMLHttpRequest();

        xhr.open(method, url);
        xhr.responseType = 'blob';

        xhr.onload = () => {

            loadingProgress.stop();

            if (200 === xhr.status) {
                download(xhr.response, getFilename(xhr), getMimeType(xhr));
                resolve();
            } else {
                reject('Failed to download.');
            }
        };

        xhr.send(body);

    });
}
